import React from "react"
import { useNavigate } from "react-router-dom"
import { useTranslation } from 'react-i18next'
import "./aboutTeaser.scss"
import { useScrollReveal } from "../../../utils/useScrollReveal"

const AboutTeaser = () => {
  const { t } = useTranslation('home')
  const navigate = useNavigate()
  const { ref, visible } = useScrollReveal<HTMLElement>()

  const goToAbout = () => {
    navigate('/about')
    window.scrollTo(0, 0)
  }

  return (
    <section className={`about-teaser${visible ? ' visible' : ''}`} id='about' ref={ref}>
      <div className='container'>
        <div className='about-teaser__grid'>
          <div className='about-teaser__image-wrap'>
            <img src='/images/about.jpg' alt={t('Le Corvier Castle', { ns: 'common' }) as string} className='about-teaser__image' />
          </div>
          <div className='about-teaser__text'>
            <span className='section-label'>{t('Our story')}</span>
            <h2>{t('Le Corvier Castle', { ns: 'common' })}</h2>
            <p className='about-teaser__intro'>{t('A magical place where one would want to stop time.')}</p>
            <p>{t('The Corvier Castle, managed by Aucoeur Service, is a magical place where one would want to stop time. Guests can wander in a forty-hectare park, wooded with extraordinary trees. A heated pool (in season) is available, as well as a barbecue. You will appreciate this stop where time takes a pause. Calm and space, comfort and the pleasure of an exchanged conversation by the fireplace.', { ns: 'about' })}</p>

            <div className='about-teaser__stats'>
              <div className='stat-item'>
                <span className='stat-item__value'>40 ha</span>
                <span className='stat-item__label'>{t('Wooded park')}</span>
              </div>
              <div className='stat-item'>
                <span className='stat-item__value'>6</span>
                <span className='stat-item__label'>{t('Guest rooms')}</span>
              </div>
              <div className='stat-item'>
                <span className='stat-item__value'>XVII<sup>e</sup></span>
                <span className='stat-item__label'>{t('Louis XIII style')}</span>
              </div>
            </div>

            <a onClick={goToAbout} className='about-teaser__link'>
              {t('Learn more')}
              <svg width="16" height="12" viewBox="0 0 16 12" fill="none">
                <path d="M9.5 1L15 6M15 6L9.5 11M15 6H0" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AboutTeaser
